// * DatePicker
// 注意：如果使用componentFactory.create()创建组件，应该将传入日期的初始值，否则dcalendar显示的选中日期为当前日期

import { Component } from 'san';
import * as $ from 'jquery';

export default class DatePicker extends Component {
    dp: any;

    constructor(options: any) {
        super(options);
    }

    initData(): {
        id: string; //[]同一页面有多个datepicker，通过id来区分
        value: string;  //[()]
        placeholder: string;    //[]
        isDirty: boolean;
        minDate: string;
        isMute: boolean;  // []无感知，伪装成纯文本
        enableManualInput: boolean; // []允许手动输入
    } {
        return {
            id: 'datepicker',
            value: '',
            placeholder: '',
            isDirty: false,
            minDate: '',
            isMute: false,
            enableManualInput: false
        };
    }

    attached() {
        this.initDatePicker();
    }

    //#region owner调用
    getDataSync(): { value: string; } {
        return {
            value: this.data.get('value')
        };
    }

    setDataSync(data: { value: string }) {
        this.data.set('value', data.value);
    }

    getIsDirtySync(): boolean {
        return this.data.get('isDirty');
    }

    resetIsDirtySync() {
        this.data.set('isDirty', false);
    }

    clearDataSync() {
        this.clear();
    }
    //#endregion

    initDatePicker() {
        const id = this.data.get('id');
        this.dp = $(`input#${id}`);
        this.dp.dcalendarpicker({
            format: 'yyyy-mm-dd'
        });
        this.dp.val(this.data.get('value'));
        this.watch('value', value => {
            this.dp.val(value);
            this.fire('value-change', this.dp.val());
        });
        if (this.data.get('enableManualInput')) {
            this.dp.off('keydown'); // 移除原keydown事件处理程序，允许手动输入
        }
    }

    updateValue() {
        this.data.set('value', this.dp.val());
        this.data.set('isDirty', true);
    }

    clear() {
        this.data.set('value', '');
        this.data.set('isDirty', true);
    }

}